
import { definitionsFromContext } from "stimulus/webpack-helpers";
import application from "stimulus_application";
import "./beds_bathrooms_slider.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
